import React from 'react'
import { Redirect } from 'react-router-dom'
import { Box } from '@deseretbook/react-ui'
import LoginForm from '../../components/users/LoginForm'
import { isAuthenticated } from '../../api/users'
import ErrorComponent from '../../components/ErrorComponent'
import LoginWrapper from './LoginWrapper'
import WaveBackground from '../../components/waveBackground/WaveBackground'

/**
 * Login page.
 */
class LoginPage extends React.Component {
  /**
   * Component constructor
   */
  constructor() {
    super()

    this.state = {
      error: null,
    }
  }

  /**
   * Catches errors when something happens.
   * @param {object} error - Caught error
   */
  componentDidCatch(error) {
    this.setState({ error })
  }

  /**
   * Determines how the component should be rendered.
   * @returns {function} Component
   */
  render() {
    const { error } = this.state

    if (error) {
      return (
        <Box>
          <ErrorComponent error={error} />
        </Box>
      )
    }

    if (isAuthenticated()) {
      return <Redirect to="/library" />
    }

    return (
      <>
        <WaveBackground />
        <LoginWrapper>
          <LoginForm />
        </LoginWrapper>
      </>
    )
  }
}

export default LoginPage
